export const messages = {
  en: {
    scheduleClasses: {
      search: {
        title: 'Search Conditions',
        nameLike: 'Please enter schedule name',
        state: 'Please select status',
        allState: 'All Status'
      },
      list: {
        title: 'Schedule Settings'
      },
      table: {
        name: 'Schedule Name',
        scheduleType: 'Schedule Type',
        scheduleCycle: 'Schedule Cycle',
        computeTime: 'Effective Time',
        staff: 'Staff',
        staffLink: 'Staff',
        state: 'Status',
        createTime: 'Create Time'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this schedule?',
        success: 'Delete successfully',
        error: 'Delete failed'
      },
      state: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to',
        schedule: 'this schedule?',
        success: 'Operation successfully',
        error: 'Operation failed'
      },
      fetchError: 'Failed to fetch schedule data'
    }
  },
  zh: {
    scheduleClasses: {
      search: {
        title: '查询条件',
        nameLike: '请输入排班名称',
        state: '请选择状态',
        allState: '全部状态'
      },
      list: {
        title: '排班设置'
      },
      table: {
        name: '班次名称',
        scheduleType: '排班类型',
        scheduleCycle: '排班周期',
        computeTime: '生效时间',
        staff: '人员',
        staffLink: '人员',
        state: '状态',
        createTime: '创建时间'
      },
      delete: {
        title: '确认操作',
        confirm: '确定删除排班吗？',
        success: '删除成功',
        error: '删除失败'
      },
      state: {
        title: '确认操作',
        confirm: '确定',
        schedule: '该排班吗？',
        success: '操作成功',
        error: '操作失败'
      },
fetchError: '获取排班数据失败'
    }
  },
  'zh-TW': {
    scheduleClasses: {
      search: {
        title: '查詢條件',
        nameLike: '請輸入排班名稱',
        state: '請選擇狀態',
        allState: '全部狀態'
      },
      list: {
        title: '排班設置'
      },
      table: {
        name: '班次名稱',
        scheduleType: '排班類型',
        scheduleCycle: '排班週期',
        computeTime: '生效時間',
        staff: '人員',
        staffLink: '人員',
        state: '狀態',
        createTime: '創建時間'
      },
      delete: {
        title: '確認操作',
        confirm: '確定刪除排班嗎？',
        success: '刪除成功',
        error: '刪除失敗'
      },
      state: {
        title: '確認操作',
        confirm: '確定',
        schedule: '該排班嗎？',
        success: '操作成功',
        error: '操作失敗'
      },
      fetchError: '獲取排班數據失敗'
    }
  }
}